// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__SAFQG","buttonOutlined":"CustomButton_buttonOutlined__A7B8k","buttonText":"CustomButton_buttonText__ViHNp"};